import React from 'react'
import point from "./../../../../Images/point.png";

const NailExtensionInMeadowsTypes = () => {
  return (
    <div className="hairSalonInSahakaraWhy">
    <h5>Types of Nail Extensions Available Near Meadows Whitefield</h5>
    <ul>
      <li>
        <span>
          <img src={point} alt="point" />
          Acrylic Nail Extensions{" "}
        </span>
        <p>
          Acrylic nails are the most popular choice for those looking for
          long-lasting nail extensions near Meadows Whitefield. They are
          perfect for individuals who have weaker nails or want nails that can
          withstand daily wear and tear. Acrylic nails are applied by mixing a
          liquid monomer and powder polymer to create a sturdy nail extension
          that is both strong and flexible.
        </p>
      </li>{" "}
      <li>
        <span>
          <img src={point} alt="point" />
          Gel Nail Extensions{" "}
        </span>
        <p>
          Gel nail extensions are another great option for nail extensions
          near Meadows Whitefield. They offer a natural, glossy finish and are
          lighter than acrylic nails. Gel nails are perfect for individuals
          who prefer a more subtle, elegant look. The gel is cured under UV
          light, ensuring that your nails remain smooth and shiny without the
          risk of chipping or cracking.
        </p>
      </li>
      <li>
        <span>
          <img src={point} alt="point" />
          Silk or Fiberglass Nail Extensions{" "}
        </span>
        <p>
          For clients who want a more lightweight and flexible option, we
          offer silk or fiberglass nail extensions. These materials are
          applied to your natural nails to add length and strength while
          maintaining a natural appearance. Silk and fiberglass nails are
          perfect for those who want a more natural look with added
          durability.
        </p>
      </li>
    </ul>
  </div>
  )
}

export default NailExtensionInMeadowsTypes
